import Tippy, { TippyProps } from '@tippyjs/react';
import cl from 'classnames';
import * as React from 'react';
import styled from 'styled-components';

import { colorsV2 } from '../../../figma/colors-v2';
import { ToolbarButtonProps } from './ToolbarButton.types';

const Main = styled.div`
  width: 32px;
  height: 32px;
  display: grid;
  place-items: center;
  svg {
    font-size: 20px;
    line-height: 0;
  }
  &.active {
    background-color: ${colorsV2.primary10};
    border-radius: 6px;
    svg {
      color: ${colorsV2.primary100};
    }
  }
`;

export const ToolbarButtonBase = ({
  className,
  icon,
  tooltip,
  active,
  onMouseDown,
}: ToolbarButtonProps) => {
  const spanProps = {
    onMouseDown,
  };

  const tooltipProps: TippyProps = {
    content: '',
    arrow: true,
    offset: [0, 17],
    delay: 0,
    duration: [200, 0],
    hideOnClick: false,
    ...tooltip,
  };

  const button = (
    <Main
      data-testid="ToolbarButton"
      className={cl(className, { active, 'slate-ToolbarButton-active': active })}
      {...spanProps}
    >
      {icon}
    </Main>
  );

  return tooltip ? <Tippy {...tooltipProps}>{button}</Tippy> : button;
};

export const ToolbarButton = ToolbarButtonBase;
